// extracted by mini-css-extract-plugin
export default {"Table__question_text":"Table_Table__question_text__x2CJV"};